import { UserGuideTarget } from "src/api/guide/guide-types";

export const guideTypeOptions = [
  { value: "", label: "전체" },
  {
    value: "USER_GUIDE_ETC",
    label: "일반",
  },
  {
    value: "USER_GUIDE_PARKINGLOT",
    label: "주차",
  },
  {
    value: "USER_GUIDE_WIFI",
    label: "네트워크",
  },
];

// 이용안내 적용대상 옵션
export const userGuideTargetOptions = [{
  label: "이용자",
  value: UserGuideTarget.GENERAL
}, {
  label: "방문자",
  value: UserGuideTarget.VISITOR
}];

// 이용안내 적용대상 텍스트
export const userGuideTargetText = (targets: Array<UserGuideTarget>) => {
  const targetLabels = userGuideTargetOptions.reduce<Array<string>>((acc, option) => {
    if (targets.includes(option.value)) {
      acc.push(option.label);
    }
    return acc;
  }, [])

  if (targetLabels.length === 0) {
    return "-";
  }
  return targetLabels.join(", ");
};